import React from 'react';
import {Icon, OptionWrapper, OptionsContainer} from './styles';

function BinaryOptions({options, selected, onClickOption, disabled, testIdPrefix}) {
  return (
    <OptionsContainer data-cy={testIdPrefix}>
      {options.map(option => (
        <OptionWrapper
          key={option.id}
          disabled={disabled}
          selected={selected === option.id}
          value={option.value}
          onClick={() => onClickOption?.(option.id)}
          data-cy={`${testIdPrefix}-${option.value ? 'checked' : 'unchecked'}`}
        >
          <Icon value={option.value} selected={selected === option.id} />
        </OptionWrapper>
      ))}
    </OptionsContainer>
  );
}

export default BinaryOptions;
